import { Component, OnInit, Optional, Self } from '@angular/core'
import {
  FormControl,
  FormControlDirective,
  FormControlName,
  FormGroupDirective,
  NgControl,
  NgModel,
} from '@angular/forms'

/**
 * @class ControlValueAccessorWrapperComponent
 * @description A base class for Angular components that wrap form controls and implement the ControlValueAccessor interface.
 * @implements {OnInit}
 *
 * @remarks
 * Implemented according to SO answer at https://stackoverflow.com/a/58551853/3158815
 */
@Component({
  selector: 'app-control-value-accessor-wrapper',
  template: '',
  standalone: true,
})
export abstract class ControlValueAccessorWrapperComponent implements OnInit {
  protected control: FormControl

  protected constructor(@Optional() @Self() public ngControl: NgControl) {
    // Setting the value accessor directly (instead of using the providers) to avoid running into a circular import.
    if (this.ngControl != null) this.ngControl.valueAccessor = this
  }

  ngOnInit(): void {
    if (this.ngControl instanceof FormControlName) {
      const formGroupDirective = this.ngControl.formDirective as FormGroupDirective
      if (formGroupDirective) {
        this.control = formGroupDirective.form.controls[this.ngControl.name] as FormControl
      }
    } else if (this.ngControl instanceof FormControlDirective) {
      this.control = this.ngControl.control
    } else if (this.ngControl instanceof NgModel) {
      this.control = this.ngControl.control
      this.control.valueChanges.subscribe((x) => this.ngControl.viewToModelUpdate(this.control.value))
    } else if (!this.ngControl) {
      this.control = new FormControl()
    }
  }

  abstract writeValue(obj: any): void
  abstract registerOnChange(fn: (_: any) => void): void
  abstract registerOnTouched(fn: any): void
}
